import styled from 'styled-components'

export const BookingErrorsWrapper = styled.div`
  color: ${({ theme }) => theme.colors.alertColor};
  font-size: ${({ theme }) => theme.fonts._14};
  line-height: ${({ theme }) => theme.fonts._18};
  padding-top: 10px;
  padding-bottom: 10px;
`
